const fashion = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652054/photo17_k5pcc2.jpg",
    alt: 'photo-one'
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652054/photo20_mptsgh.jpg",
    alt: 'photo-two'
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652047/photo12_dclhis.jpg",
    alt: 'photo-two'
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652032/KWP_9750w_ike5kv.jpg",
    alt: 'photo-one'
  },
  {
    id: 5,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651968/KWP_7078_adss6x.jpg",
    alt: 'photo-one'
  },
  {
    id: 6,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651956/KWP_5980_qok64u.jpg",
    alt: 'photo-one'
  },
  {
    id: 7,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651942/KWP_6639_ahfmtc.jpg",
    alt: 'photo-one'
  },
  {
    id: 8,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651927/KWP_4431_qsdf7b.jpg",
    alt: 'photo-one'
  },
  {
    id: 9,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651918/KWP_4563_t6bhni.jpg",
    alt: 'photo-one'
  },
  {
    id: 10,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651907/KWP_4109_rgskmg.jpg",
    alt: 'photo-one'
  },
  {
    id: 11,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651903/KWP_2556_mle1nr.jpg",
    alt: 'photo-one'
  },
  {
    id: 12,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651876/KWP_0300_yjjesc.jpg",
    alt: 'photo-one'
  },
  {
    id: 13,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677285/KWP_9603_udcknr.jpg",
    alt: 'photo-one'
  },
  {
    id: 14,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677279/KWP_9596_ljzi6d.jpg",
    alt: 'photo-one'
  },
  {
    id: 15,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677279/KWP_9622_nylhdm.jpg",
    alt: 'photo-one'
  },
  {
    id: 16,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677276/KWP_9591_f3opnl.jpg",
    alt: 'photo-one'
  },
  {
    id: 17,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677252/KWP_9550_b0ybcm.jpg",
    alt: 'photo-one'
  },
  {
    id: 18,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677247/KWP_9482_sr9ewn.jpg",
    alt: 'photo-one'
  },
  {
    id: 19,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677240/KWP_9431_dmlicy.jpg",
    alt: 'photo-one'
  },
  {
    id: 20,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677240/KWP_9539_vs2owh.jpg",
    alt: 'photo-one'
  },
  {
    id: 21,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740677235/KWP_9442_fmfcjt.jpg",
    alt: 'photo-one'
  },
]


export default fashion;
